export const TREE_MAP = "TreeMap"
export const HORIZONTAL_BAR_CHART = "HorizontalBarChart"
export const PIE_CHART = "PieChart"

export type ChartType = "PieChart"

export const WALMART_COLORS: string[] = [
	"#004F9A",
	"#DB6BB1",
	"#CC851A",
	"#459FBC",
	"#AF2F00",
	"#A184B2",
	"#3F931C",
	"#A22373",
]

export const GENDER_COLORS: string[] = ["#004F9A", "#DB6BB1", "#CC851A"]
